<template>
	<div>
		<kit-vimeo-player 
			:video-url="movie_session.vimeo_link"
			:autoplay="true"
			:controls="false"
			class="vimeo-container"
			ref="vimeo_player"
			v-if="movie_session"
		/>
	</div>
</template>

<script>
import axios from 'axios'
import KitVimeoPlayer from './KitVimeoPlayer'

export default{
	name: 'TicketOnlineViewTest',
	components: {
		KitVimeoPlayer
	},
	props: {
		movie_session_id: {
			required: true
		}
	},
	data(){
		return {
			movie_session: null
		}
	},
	mounted(){
		console.log('eeee')
		this.getMovieSession()
	},
	methods: {
		async getMovieSession(){
			await axios.get(`${process.env.VUE_APP_API_LOCATION}/api/movie_sessions/${this.movie_session_id}/foyer_test`).then(r => {
				this.movie_session = r.data.data
			})
		}
	}
}
</script>